/* Apercu du titre personnalise, cote site.
 *
 * Ce fichier est une TRADUCTION de `08-DEV-OUTILS/feuilles/perso.py`, pas une
 * imitation libre : meme recherche de taille, meme regle de bascule a deux
 * lignes, meme coupure au mot le plus equilibre, meme ancrage sur la boite
 * des capitales de « HXAEIOU ».
 *
 * Il ne charge AUCUNE police. « Sailors 1 » est achetee et sa licence web est
 * introuvable, donc la publier en webfont n'etait pas une option. A la place,
 * les lettres arrivent en images, rendues par le moteur lui-meme, avec la
 * table de leurs avances. C'est plus sur juridiquement, et plus fidele : les
 * formes viennent litteralement de l'imprimante.
 *
 * Trois choses ont ete mesurees avant d'ecrire ca :
 *   - coller les lettres une a une aux avances de PIL redonne exactement le
 *     rendu de la chaine entiere (zero pixel d'ecart) ;
 *   - la table des avances redonne la meme mise en page que le moteur sur
 *     400 titres tires au hasard, taille comprise, zero divergence ;
 *   - le placement tombe au pixel pres : glisser le rendu Python d'un seul
 *     pixel fait tripler l'ecart.
 *
 * Aucun nombre n'est recopie a la main : tout vient de `constantes.json` et
 * `glyphes.json`, tous deux ecrits par le moteur.
 */
(function (global) {
  "use strict";

  /* C : constantes.json — G : glyphes.json — planche : l'Image des lettres */
  function creerMoteur(C, ctx, G, planche) {
    var PAS = G.tailles.pas, MIN = G.tailles.min;
    var NB = G.capitales.length;

    function indice(taille) { return (taille - MIN) / PAS; }
    function taille(i) { return MIN + i * PAS; }

    /* La largeur d'un texte, en additionnant les avances de ses lettres. Sans
     * crenage, comme le moteur : la PIL installee n'a pas Raqm, donc elle pose
     * les glyphes a leur avance nue. */
    function largeur(texte, i) {
      var s = 0;
      for (var k = 0; k < texte.length; k++) {
        var a = G.avances_64[texte[k]];
        if (a) s += a[i];
      }
      return s / 64;
    }

    /* `texte_ajuste` : la plus grande taille qui ne depasse ni la hauteur
     * visee (mesuree sur les capitales de reference, jamais sur le texte,
     * sinon un accent circonflexe ferait retrecir le titre) ni la largeur
     * du bandeau. */
    function ajuster(texte, hauteurCible, largeurMax) {
      for (var i = 0; i < NB; i++) {
        if (G.capitales[i] >= hauteurCible || largeur(texte, i) >= largeurMax) {
          return taille(Math.max(0, i - 1));
        }
      }
      return taille(NB - 1);
    }

    /* Coupe au mot, la ou les deux moities pesent le plus egalement. On
     * compare des largeurs, pas des nombres de lettres : « LES » et « MMM »
     * font trois caracteres et pas du tout la meme place. */
    function couper(titre) {
      var mots = titre.split(" ").filter(Boolean);
      if (mots.length < 2) return null;
      var i = indice(200), best = null, ecart = null;
      for (var k = 1; k < mots.length; k++) {
        var h = mots.slice(0, k).join(" "), b = mots.slice(k).join(" ");
        var e = Math.abs(largeur(h, i) - largeur(b, i));
        if (ecart === null || e < ecart) { best = [h, b]; ecart = e; }
      }
      return best;
    }

    /* Capitales, espaces propres, coupe au dernier mot entier, et retrait de
     * ce que la police ne sait pas dessiner : un caractere absent sortirait en
     * rectangle vide a l'impression. Le champ refuse avant, pas la machine
     * apres. */
    /* Les signes que les claviers produisent a la place des notres. iOS
     * remplace l'apostrophe droite par une apostrophe courbe sans prevenir :
     * sans cette table, « L'ETE DE ROSALIE » perdait son apostrophe en
     * silence. Les tirets longs et les guillemets suivent la meme logique. */
    var EQUIV = {
      "’": "'", "‘": "'", "ʼ": "'", "`": "'", "´": "'",
      "–": "-", "—": "-", "−": "-",
      "«": "", "»": "", "“": "", "”": "", "\"": "",
      " ": " ", " ": " "
    };

    function normaliser(texte, enCours) {
      var t = String(texte || "").toLocaleUpperCase("fr");
      t = t.split("").map(function (c) {
        return EQUIV[c] !== undefined ? EQUIV[c] : c;
      }).join("");
      t = t.split("").filter(function (c) {
        return G.avances_64[c] !== undefined;
      }).join("");

      /* `enCours` vaut vrai pendant la frappe. Sans lui, l'espace qu'on vient
       * de taper etait avale par le nettoyage a chaque touche, et il devenait
       * IMPOSSIBLE d'ecrire deux mots. On garde donc un espace final unique
       * tant que la cliente ecrit, et on le retire quand elle a fini. */
      var finitParEspace = /\s$/.test(t);
      t = t.split(/\s+/).filter(Boolean).join(" ");
      if (enCours && finitParEspace && t && t.length < C.max_car) t += " ";

      if (t.length <= C.max_car) return t;
      var coupe = t.slice(0, C.max_car);
      if (coupe.indexOf(" ") !== -1 && !/\s/.test(t.charAt(C.max_car))) {
        coupe = coupe.slice(0, coupe.lastIndexOf(" "));
      }
      return enCours ? coupe : coupe.trim();
    }

    function miseEnPage(titre) {
      var t1 = ajuster(titre, C.cap, C.largeur);
      var cap1 = G.capitales[indice(t1)];
      if (cap1 >= C.seuil) return { lignes: [titre], taille: t1, capitale: cap1 };

      var deux = couper(titre);
      if (!deux) return { lignes: [titre], taille: t1, capitale: cap1 };

      var t2 = Math.min(ajuster(deux[0], C.cap_max_2l, C.largeur),
                        ajuster(deux[1], C.cap_max_2l, C.largeur));
      return { lignes: deux, taille: t2, capitale: G.capitales[indice(t2)] };
    }

    /* Ou tombe chaque lettre, dans le repere du gabarit (4219 x 5625). */
    function placer(titre) {
      var p = miseEnPage(titre);
      var i = indice(p.taille);
      var gouttiere = Math.round(C.gouttiere * C.cap);
      var pas = p.capitale + gouttiere;
      var hautBloc = p.capitale * p.lignes.length +
                     gouttiere * (p.lignes.length - 1);
      var y0 = C.milieu - Math.floor(hautBloc / 2);
      var k = p.taille / G.ref;          // la planche est rendue a G.ref px

      var lettres = [];
      p.lignes.forEach(function (ligne, n) {
        var x = C.titre_centre - largeur(ligne, i) / 2;
        /* Python pose le texte par le haut de LIGNE (`anchor="la"`), alors
         * que `y0` est le haut de l'encre des capitales. `cap_haut` est la
         * distance entre les deux, mesuree et exportee par le moteur : c'est
         * le `gc[1]` de `poser_titre`. */
        var hautLigne = y0 + n * pas - G.cap_haut[i];
        for (var c = 0; c < ligne.length; c++) {
          var b = G.cases[ligne[c]];
          if (b) {
            lettres.push({ b: b, x: x - G.marge * k, y: hautLigne - G.marge * k,
                           l: b.l * k, h: b.h * k });
            x += G.avances_64[ligne[c]][i] / 64;
          }
        }
      });
      return { infos: p, lettres: lettres };
    }

    /* Un calque des lettres seules, teinte d'une couleur. La planche est en
     * blanc sur transparent : `source-in` la repeint sans qu'il faille deux
     * fichiers, un pour l'encre et un pour l'ombre. */
    function calque(lettres, couleur, dx, dy) {
      var c = document.createElement("canvas");
      c.width = ctx.canvas.width;
      c.height = ctx.canvas.height;
      var x = c.getContext("2d");
      var m = ctx.getTransform();
      x.setTransform(m.a, m.b, m.c, m.d, m.e, m.f);
      lettres.forEach(function (l) {
        x.drawImage(planche, l.b.x, l.b.y, l.b.l, l.b.h,
                    l.x + dx, l.y + dy, l.l, l.h);
      });
      x.setTransform(1, 0, 0, 1, 0, 0);
      x.globalCompositeOperation = "source-in";
      x.fillStyle = couleur;
      x.fillRect(0, 0, c.width, c.height);
      return c;
    }

    /* Dessine dans le repere du gabarit : l'appelant a deja mis le canvas a
     * l'echelle, personne ne convertit de coordonnees ici. */
    function dessiner(titre) {
      var p = placer(titre);
      var K = ctx.getTransform().a;      // l'echelle posee par l'appelant
      var o = C.ombre;

      var ombre = calque(p.lettres, "rgb(" + o.couleur[0] + "," + o.couleur[1] +
                         "," + o.couleur[2] + ")", o.dx, o.dy);
      var encre = calque(p.lettres, "rgb(" + C.encre[0] + "," + C.encre[1] +
                         "," + C.encre[2] + ")", 0, 0);

      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      /* Le flou du moteur vaut 11 px de gabarit : a l'ecran il doit suivre
       * l'echelle, sinon l'ombre est cinq fois trop etalee. */
      ctx.filter = "blur(" + (o.flou * K) + "px)";
      ctx.globalAlpha = o.couleur[3] / 255;
      ctx.drawImage(ombre, 0, 0);
      ctx.filter = "none";
      ctx.globalAlpha = 1;
      ctx.drawImage(encre, 0, 0);
      ctx.restore();

      return { titre: titre, lignes: p.infos.lignes.length,
               capitale: p.infos.capitale, police_px: p.infos.taille,
               caracteres: titre.length };
    }

    return { normaliser: normaliser, miseEnPage: miseEnPage,
             dessiner: dessiner, ajuster: ajuster, couper: couper,
             largeur: largeur, indice: indice };
  }

  /* Charge les trois fichiers du moteur et rend une fabrique prete a servir.
   *
   * Accepte soit un prefixe ("" en local, ou un dossier), soit trois URLs
   * explicites : sur Shopify les assets portent un nom different et une
   * chaine de version, on ne peut donc pas les deviner depuis un prefixe. */
  function charger(ou) {
    var u = typeof ou === "object" && ou ? ou : {
      constantes: (ou || "") + "constantes.json",
      glyphes: (ou || "") + "glyphes.json",
      planche: (ou || "") + "glyphes.webp"
    };
    return Promise.all([
      fetch(u.constantes).then(function (r) { return r.json(); }),
      fetch(u.glyphes).then(function (r) { return r.json(); }),
      new Promise(function (ok, ko) {
        var im = new Image();
        im.onload = function () { ok(im); };
        im.onerror = ko;
        im.src = u.planche;
      })
    ]).then(function (r) {
      return {
        C: r[0], G: r[1], planche: r[2],
        moteur: function (ctx) { return creerMoteur(r[0], ctx, r[1], r[2]); }
      };
    });
  }

  global.ApercuTitre = { creerMoteur: creerMoteur, charger: charger };
})(this);
